type AuthModalType = typeof import('./index');

export default function authModal(): Promise<AuthModalType> {
    return import(
        /* webpackChunkName: "AuthModal" */
        './index.js'
    );
}
